'use-strict';

var TYPE_UNSPECIFIED = 0;
module.exports.TYPE_UNSPECIFIED = TYPE_UNSPECIFIED;

var TYPE_FACEBOOK = 1;
module.exports.TYPE_FACEBOOK = TYPE_FACEBOOK;

var TYPE_FACEBOOK_AD = 101;
module.exports.TYPE_FACEBOOK_AD = TYPE_FACEBOOK_AD;

var TYPE_INSTAGRAM = 2;
module.exports.TYPE_INSTAGRAM = TYPE_INSTAGRAM;

var TYPE_TWITTER = 3;
module.exports.TYPE_TWITTER = TYPE_TWITTER;

var TYPE_LINKEDIN = 4;
module.exports.TYPE_LINKEDIN = TYPE_LINKEDIN;

var TYPE_PINTEREST = 5;
module.exports.TYPE_PINTEREST = TYPE_PINTEREST;

var TYPE_GOOGLE_PLUS = 6;
module.exports.TYPE_GOOGLE_PLUS = TYPE_GOOGLE_PLUS;

var TYPE_WORDPRESS = 7;
module.exports.TYPE_WORDPRESS = TYPE_WORDPRESS;

var TYPE_GOOGLE_MY_BUSINESS = 8;
module.exports.TYPE_GOOGLE_MY_BUSINESS = TYPE_GOOGLE_MY_BUSINESS;

var TYPE_THREADS = 9;
module.exports.TYPE_THREADS = TYPE_THREADS;

var TYPE_TIKTOK = 10;
module.exports.TYPE_TIKTOK = TYPE_TIKTOK;

var TYPE_YOUTUBE = 11;
module.exports.TYPE_YOUTUBE = TYPE_YOUTUBE;

var TYPE = {
  FACEBOOK: TYPE_FACEBOOK,
  FACEBOOK_AD: TYPE_FACEBOOK_AD,
  INSTAGRAM: TYPE_INSTAGRAM,
  TWITTER: TYPE_TWITTER,
  LINKEDIN: TYPE_LINKEDIN,
  PINTEREST: TYPE_PINTEREST,
  GOOGLE_PLUS: TYPE_GOOGLE_PLUS,
  WORDPRESS: TYPE_WORDPRESS,
  GOOGLE_MY_BUSINESS: TYPE_GOOGLE_MY_BUSINESS,
  TIKTOK: TYPE_TIKTOK,
  YOUTUBE: TYPE_YOUTUBE,
  THREADS: TYPE_THREADS,
  UNSPECIFIED: TYPE_UNSPECIFIED,
};
module.exports.TYPE = TYPE;


var NAME_FACEBOOK = 'facebook';
module.exports.NAME_FACEBOOK = NAME_FACEBOOK;

var NAME_FACEBOOK_AD = 'facebook';
module.exports.NAME_FACEBOOK_AD = NAME_FACEBOOK_AD;

var NAME_INSTAGRAM = 'instagram';
module.exports.NAME_INSTAGRAM = NAME_INSTAGRAM;

var NAME_TWITTER = 'twitter';
module.exports.NAME_TWITTER = NAME_TWITTER;

var NAME_LINKEDIN = 'linkedin';
module.exports.NAME_LINKEDIN = NAME_LINKEDIN;

var NAME_PINTEREST = 'pinterest';
module.exports.NAME_PINTEREST = NAME_PINTEREST;

var NAME_GOOGLE_PLUS = 'google_plus';
module.exports.NAME_GOOGLE_PLUS = NAME_GOOGLE_PLUS;

var NAME_WORDPRESS = 'wordpress';
module.exports.NAME_WORDPRESS = NAME_WORDPRESS;

var NAME_GOOGLE_MY_BUSINESS = 'google_my_business';
module.exports.NAME_GOOGLE_MY_BUSINESS = NAME_GOOGLE_MY_BUSINESS;

var NAME_TIKTOK = 'tiktok';
module.exports.NAME_TIKTOK = NAME_TIKTOK;

var NAME_YOUTUBE = 'youtube';
module.exports.NAME_YOUTUBE = NAME_YOUTUBE;

var NAME_THREADS = 'threads';
module.exports.NAME_THREADS = NAME_THREADS;

var NAME_UNSPECIFIED = 'unspecified';
module.exports.NAME_UNSPECIFIED = NAME_UNSPECIFIED;

var NAME = {
  FACEBOOK: NAME_FACEBOOK,
  FACEBOOK_AD: NAME_FACEBOOK_AD,
  INSTAGRAM: NAME_INSTAGRAM,
  TWITTER: NAME_TWITTER,
  LINKEDIN: NAME_LINKEDIN,
  PINTEREST: NAME_PINTEREST,
  GOOGLE_PLUS: NAME_GOOGLE_PLUS,
  WORDPRESS: NAME_WORDPRESS,
  GOOGLE_MY_BUSINESS: NAME_GOOGLE_MY_BUSINESS,
  TIKTOK: NAME_TIKTOK,
  YOUTUBE: NAME_YOUTUBE,
  THREADS: NAME_THREADS,
  UNSPECIFIED: NAME_UNSPECIFIED,
};
module.exports.NAME = NAME;

var PAGE_TYPE_NAMES = {
  [TYPE_FACEBOOK]: NAME_FACEBOOK,
  [TYPE_FACEBOOK_AD]: NAME_FACEBOOK_AD,
  [TYPE_INSTAGRAM]: NAME_INSTAGRAM,
  [TYPE_TWITTER]: NAME_TWITTER,
  [TYPE_LINKEDIN]: NAME_LINKEDIN,
  [TYPE_PINTEREST]: NAME_PINTEREST,
  [TYPE_GOOGLE_PLUS]: NAME_GOOGLE_PLUS,
  [TYPE_WORDPRESS]: NAME_WORDPRESS,
  [TYPE_GOOGLE_MY_BUSINESS]: NAME_GOOGLE_MY_BUSINESS,
  [TYPE_TIKTOK]: NAME_TIKTOK,
  [TYPE_YOUTUBE]: NAME_YOUTUBE,
  [TYPE_THREADS]: NAME_THREADS,
  [TYPE_UNSPECIFIED]: NAME_UNSPECIFIED,
};
module.exports.PAGE_TYPE_NAMES = PAGE_TYPE_NAMES;
